import React from "react";
import { HEALTHCARE_EXTRA_FLOW_CONFIGS } from "./healthcareProcessFlowExtra";

const FLOW_CONFIGS = HEALTHCARE_EXTRA_FLOW_CONFIGS;
const STEP_COUNT = 6;

const styles = `
  .hc-diag {
    background: #fff;
    border-radius: 8px;
    overflow: hidden;
    border: 1px solid #dbe7f7;
    font-family: Roboto, sans-serif;
  }
  .hc-diag-head {
    background: #1d3f7d;
    padding: 14px 16px 12px;
    text-align: center;
  }
  .hc-diag-head h4 {
    font-family: Exo, sans-serif;
    font-size: 15px;
    font-weight: 700;
    color: #fff;
    margin: 0 0 4px;
    line-height: 1.25;
  }
  .hc-diag-head p {
    margin: 0;
    font-size: 11px;
    color: rgba(255, 255, 255, 0.85);
    line-height: 1.4;
  }
  .hc-diag-hitl {
    background: #f4f7fb;
    padding: 10px 12px 6px;
    border-bottom: 1px solid #e2eaf4;
  }
  .hc-diag-hitl-label {
    font-family: Exo, sans-serif;
    font-size: 9px;
    font-weight: 700;
    color: #c45d1e;
    text-transform: uppercase;
    letter-spacing: 0.06em;
    text-align: center;
    margin: 0 0 8px;
  }
  .hc-diag-hitl-row,
  .hc-diag-body {
    display: grid;
    grid-template-columns: 108px repeat(${STEP_COUNT}, minmax(0, 1fr)) 108px;
    gap: 4px;
    min-width: 0;
  }
  .hc-diag-hitl-pill {
    grid-column: span 2;
    background: linear-gradient(180deg, #f5a84c 0%, #e8913a 100%);
    color: #fff;
    font-family: Exo, sans-serif;
    font-size: 9px;
    font-weight: 600;
    text-align: center;
    padding: 6px 4px;
    border-radius: 6px;
    line-height: 1.25;
    box-shadow: 0 2px 4px rgba(232, 145, 58, 0.3);
  }
  .hc-diag-io {
    background: #f0f6fc;
    border: 1px solid #d4e3f5;
    border-radius: 6px;
    padding: 8px 8px 10px;
    align-self: stretch;
  }
  .hc-diag-io h5 {
    font-family: Exo, sans-serif;
    font-size: 9px;
    font-weight: 700;
    color: #1d3f7d;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    margin: 0 0 6px;
    text-align: center;
  }
  .hc-diag-io ul {
    margin: 0;
    padding: 0 0 0 14px;
    font-size: 8px;
    color: #3a4d62;
    line-height: 1.45;
  }
  .hc-diag-step {
    background: linear-gradient(180deg, #ffffff 0%, #f7fbff 100%);
    border: 1px solid #d4e3f5;
    border-radius: 6px;
    padding: 6px 5px 5px;
    display: flex;
    flex-direction: column;
    min-height: 118px;
  }
  .hc-diag-step-head {
    display: flex;
    align-items: center;
    gap: 4px;
    margin-bottom: 4px;
  }
  .hc-diag-step-num {
    width: 14px;
    height: 14px;
    border-radius: 50%;
    background: #1d3f7d;
    color: #fff;
    font-size: 8px;
    font-weight: 700;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
  }
  .hc-diag-step-title {
    font-family: Exo, sans-serif;
    font-size: 8px;
    font-weight: 700;
    color: #1d3f7d;
    line-height: 1.2;
  }
  .hc-diag-step-icon {
    text-align: center;
    color: #27baa7;
    font-size: 16px;
    margin: 2px 0 4px;
  }
  .hc-diag-step-tasks {
    margin: 0 0 auto;
    padding: 0 0 0 10px;
    font-size: 7px;
    color: #4a5d72;
    line-height: 1.35;
    flex: 1;
  }
  .hc-diag-step-agent {
    margin-top: 4px;
    padding-top: 4px;
    border-top: 1px dashed #d4e3f5;
    text-align: center;
  }
  .hc-diag-step-agent strong {
    display: block;
    font-size: 7px;
    color: #1d3f7d;
    line-height: 1.2;
  }
  .hc-diag-step-agent span {
    font-size: 6px;
    color: #27baa7;
    text-transform: uppercase;
    letter-spacing: 0.04em;
  }
  .hc-diag-systems {
    background: #1d3f7d;
    padding: 8px 12px;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 6px;
    justify-content: center;
  }
  .hc-diag-systems span {
    font-family: Exo, sans-serif;
    font-size: 8px;
    font-weight: 600;
    color: #1d3f7d;
    background: #fff;
    border-radius: 4px;
    padding: 3px 8px;
  }
  .hc-diag-systems p {
    margin: 0;
    font-size: 8px;
    color: rgba(255, 255, 255, 0.8);
    line-height: 1.4;
  }
  .hc-diag-scroll {
    overflow-x: auto;
    scrollbar-width: thin;
  }
  @media (max-width: 900px) {
    .hc-diag-hitl-row,
    .hc-diag-body {
      min-width: 760px;
    }
  }
`;

function CheckpointPill({ label, startCol }) {
  return (
    <div className="hc-diag-hitl-pill" style={{ gridColumn: `${startCol} / span 2` }}>
      {label}
    </div>
  );
}

export default function HealthcareProcessFlow({ useCaseId }) {
  const config = FLOW_CONFIGS[useCaseId];
  if (!config) return null;

  return (
    <div className="hc-diag" role="img" aria-label={config.title}>
      <style>{styles}</style>

      <header className="hc-diag-head">
        <h4>{config.title}</h4>
        <p>{config.subtitle}</p>
      </header>

      <div className="hc-diag-scroll">
        {config.checkpoints.length > 0 && (
          <div className="hc-diag-hitl">
            <p className="hc-diag-hitl-label">Human-in-the-loop checkpoints</p>
            <div className="hc-diag-hitl-row">
              {config.checkpoints.map((cp) => (
                <CheckpointPill key={cp.label} label={cp.label} startCol={cp.startCol} />
              ))}
            </div>
          </div>
        )}

        <div className="hc-diag-body">
          <aside className="hc-diag-io" aria-label="Inputs">
            <h5>Inputs</h5>
            <ul>
              {config.inputs.map((item) => (
                <li key={item}>{item}</li>
              ))}
            </ul>
          </aside>

          {config.steps.map((step) => {
            const Icon = step.icon;
            return (
              <div key={step.id} className="hc-diag-step">
                <div className="hc-diag-step-head">
                  <span className="hc-diag-step-num">{step.id}</span>
                  <span className="hc-diag-step-title">{step.title}</span>
                </div>
                <div className="hc-diag-step-icon" aria-hidden="true">
                  <Icon />
                </div>
                <ul className="hc-diag-step-tasks">
                  {step.tasks.map((task) => (
                    <li key={task}>{task}</li>
                  ))}
                </ul>
                <footer className="hc-diag-step-agent">
                  <strong>{step.agent}</strong>
                  <span>{step.agentRole}</span>
                </footer>
              </div>
            );
          })}

          <aside className="hc-diag-io" aria-label="Outputs">
            <h5>Outputs</h5>
            <ul>
              {config.outputs.map((item) => (
                <li key={item}>{item}</li>
              ))}
            </ul>
          </aside>
        </div>
      </div>

      <footer className="hc-diag-systems">
        <p>Systems:</p>
        {config.systems.map((system) => (
          <span key={system}>{system}</span>
        ))}
      </footer>
    </div>
  );
}

